import Vue from 'vue';
import Vuetify from 'vuetify/lib'



Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  theme: {
    themes: {
      light: {
        primary: '#FFF',
        secondary: '#EFAA42',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
})